var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.187 12.6818C14.0703 12.6702 13.9303 12.6702 13.802 12.6818C11.0253 12.5885 8.82031 10.3135 8.82031 7.5135C8.82031 4.65516 11.1303 2.3335 14.0003 2.3335C16.8586 2.3335 19.1803 4.65516 19.1803 7.5135C19.1686 10.3135 16.9636 12.5885 14.187 12.6818Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35187 16.9865C5.52854 18.8765 5.52854 21.9565 8.35187 23.8348C11.5602 25.9815 16.8219 25.9815 20.0302 23.8348C22.8535 21.9448 22.8535 18.8648 20.0302 16.9865C16.8335 14.8515 11.5719 14.8515 8.35187 16.9865Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.88805aca89348154308a9ca0c9c5b0cf.svg";
export { ForwardRef as ReactComponent };